<template>
  <div class="box">
    <div class="h_title">我的合同</div>
    <div class="profileList">
      <div
        class="profileList_item"
        v-for="item in list"
        :key="item.key"
        @click="toPath(item)"
      >
        <div class="lable">{{ item.lable }}</div>
        <div class="value">{{ profileData[item.key] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "my-contract",
  data() {
    return {
      list: [
        {
          lable: "签署中",
          key: "inProgressCount",
          path: "/electronicDocumentsList",
          query: { state: "IN_PROGRESS" },
        },
        {
          lable: "签署完成",
          key: "finishedCount",
          path: "/electronicDocumentsList",
          query: { state: "FINISHED" },
        },
        {
          lable: "已撤销",
          key: "canceledCount",
          path: "/electronicDocumentsList",
          query: { state: "CANCELED" },
        },
        {
          lable: "待归档",
          key: "unarchivedCount",
          name: "electronicDocumentsList",
          params: { dirId: -1 },
        },
      ],
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      profileData: (state) => state.electronic.contractProfile,
    }),
  },
  methods: {
    toPath(item) {
      if (item.name) {
        this.$router.push({ name: item.name, params: item.params });
      } else {
        this.$router.push({ path: item.path, query: item.query });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '../homeStyle.scss' as *;

.box {
  width: 100%;
  height: 130px;
  border-radius: $border-radius;
  background: $primary-color;
  color: $font-j-0 !important;
  .h_title {
    color: $font-j-0;
  }
}
</style>
